module.exports = __webpack_public_path__ + "static/media/loadingImage.80cb09cb.gif";